module.exports = __webpack_public_path__ + "img/8-y-old-houdini.b0ca35e.jpg";